export type room = {
    _id: string;
    code: string;
    description: string;
    ipAddress: string;
    raspberrySetupIpAddress: string;
    accessRule?: accessrule;
    stayingMinutes?: number;
    reservableFrom?: Date;
    reservableTo?: Date;
};
export const dayMaps = [
    { name: "Lunedì", field: "monday" },
    { name: "Martedì", field: "tuesday" },
    { name: "Mercoledì", field: "wednesday" },
    { name: "Giovedì", field: "thursday" },
    { name: "Venerdì", field: "friday" },
    { name: "Sabato", field: "saturday" },
    { name: "Domenica", field: "sunday" },
];
export type accessrule = {
    monday: openingDetail;
    tuesday: openingDetail;
    wednesday: openingDetail;
    thursday: openingDetail;
    friday: openingDetail;
    saturday: openingDetail;
    sunday: openingDetail;
    closingDays: Date[];
    temporaryConfig: temporaryConfig[];
    capacity: number;
};
export type temporaryConfig = {
    date: Date;
    openingDetail: openingDetail;
}
export type time = {
    hours: number;
    minutes: number;
};
export type openingDetail = {
    openingTime: time;
    closingTime: time;
    duration: number;
};
export const emptyRoom = (): room => ({
    _id: "",
    code: "",
    description: "",
    ipAddress: "",
    raspberrySetupIpAddress: "",
    accessRule: undefined,
});
